// dependencies
import { Link } from "yarrr";
import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

// css
import css from "./ExtraMenu";

const ExtraMenu = (props) => {
	const { links } = props;

	const [isOpen, setIsOpen] = useState(false);
	const menuRef = useRef();

	const changeOpenState = (nextState = !isOpen) => {
		setIsOpen(nextState);
	};

	const handleDocumentClick = (event) => {
		if (menuRef.current && !menuRef.current.contains(event.target)) {
			changeOpenState(false);
		}
	};

	useEffect(() => {
		if (isOpen) {
			document.addEventListener("click", handleDocumentClick);
		} else {
			document.removeEventListener("click", handleDocumentClick);
		}

		// Cleanup
		return () => {
			document.removeEventListener("click", handleDocumentClick);
		};
	}, [isOpen]);

	return (
		<div ref={menuRef} className={`${css.main} ${isOpen ? css.isOpen : ""}`}>
			<div onClick={() => changeOpenState()} className={css.mainLabel}>
				<div className={css.innerLabel}>More</div>
				<div className={css.iconContainer}>
					{isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
				</div>
			</div>

			{isOpen ? (
				<div className={css.dropDownContainer}>
					<div className={css.dropDownItems}>
						{links.map((link) => (
							<div key={link.name} onClick={() => changeOpenState(false)}>
								<Link href={link.href} className={css.dropDownItem}>
									{link.label}
								</Link>
							</div>
						))}
					</div>
				</div>
			) : null}
		</div>
	);
};

ExtraMenu.propTypes = {
	links: PropTypes.array.isRequired,
};

export default ExtraMenu;
